<template align="center">
  <div class="animated fadeIn">
    <!-- summary -->
    <vcl-facebook v-if="loading_summary"></vcl-facebook>
    <b-row v-else>
      <b-col sm="6" md="4">
        <b-card no-body class="bg-success">
          <b-card-body class="pb-0">
            <h1><strong><sup style="font-size: 20px">Help Desk (Group : {{ dashboard.group_count ? dashboard.group_count : 0 }})</sup></strong></h1>
            <hr>
            <h4>Notice : {{ dashboard.notice ? dashboard.notice : 0}} </h4>
            <h4 v-if="dashboard.qna < 1"> QNA : {{ dashboard.qna }} </h4>
            <h4 v-else><b-badge variant="warning"> QNA : {{ dashboard.qna }} </b-badge></h4>
            <h4 v-if="dashboard.request_signout < 1"> Signout : {{ dashboard.request_signout || 0 }} </h4>
            <h4 v-else><b-badge variant="danger"> Signout : {{ dashboard.request_signout || 0 }} </b-badge></h4>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="4">
        <b-card no-body class="bg-primary">
          <b-card-body class="pb-0">
            <h1><strong><sup style="font-size: 20px">Total Billing</sup></strong></h1>
            <span>(Only on the invoices issued)</span>
            <hr>
            <!-- <h4>Fee : {{ dashboard.total_fee | dollar }} </h4> -->
            <!-- 발행된 인보이스에 한해 총 매출 -->
            <h4>Sales : {{ dashboard.total_sales | dollar }} </h4>
            <!-- 발행된 인보이스에 한해 총 미수금 -->
            <h4>Remain : {{ dashboard.total_remain | dollar }} </h4>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="4">
        <b-card no-body class="bg-info">
          <b-card-body class="pb-0">
            <h1><strong><sup style="font-size: 20px">This Month Billing</sup></strong></h1>
            <small>(It may vary depending on the usage.)</small>
            <hr>
            <!-- <h4>Base : {{ dashboard.month_base_price | dollar }} </h4> -->
            <!-- <h4>Fee : {{ (dashboard.month_fee || 0) | dollar }} </h4> -->
            <h5>Advance : {{ dashboard.month_advance_payment | dollar }} </h5>
            <!-- 총 매출 -->
            <h5>Sales : {{ dashboard.month_base_price | dollar }} </h5>
            <!-- 미수금 -->
            <h5>Estimated : {{ dashboard.month_total_price | dollar }} </h5>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <vcl-facebook v-if="loading_chart"></vcl-facebook>
    <b-row v-else>
      <b-col md="12">
        <b-card>
          <center>
            <h4>Recent Monthly Sales Information</h4>
          </center>
          <hr>
          <b-row v-if="monthly">
            <b-col sm="12" lg="12">
              <center>
                <span v-if="((dashboard.wmds_count || 0) + (dashboard.wsf_count || 0) + (dashboard.wc_count || 0)) < 1">No have recently invoice</span>
                <small v-else>The last 12 months are displayed.</small>
              </center>
              <line-chart v-if="((dashboard.wmds_count || 0) + (dashboard.wsf_count || 0) + (dashboard.wc_count || 0)) > 0" :data="monthly" :min="0" />
            </b-col>
          </b-row>
          <b-row v-else>
            <b-col sm="12">
              <center>
                No bills have been issued.
              </center>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <vcl-facebook v-if="loading_info"></vcl-facebook>
    <b-row v-else>
      <b-col sm="6" md="3">
        <b-card>
          <pie-chart v-if="chart_circle.with_partnership && chart_circle.with_partnership.length" class="animated fadeIn" :donut="true" :data="chart_circle.with_partnership" :colors="['skyblue', 'green']"></pie-chart>
          <center v-else>No have install agent from clients</center>
          <hr>
          <center>
            <p> Partnership Level : {{chart_circle.level < 0 ?  0  : chart_circle.level }} </p>
          </center>
        </b-card>
      </b-col>
      <b-col sm="6" md="3">
        <b-card>
          <pie-chart v-if="chart_circle.service_data && chart_circle.service_data.length" class="animated fadeIn" :donut="true" :data="chart_circle.service_data" :colors="['red', 'teal', 'silver']"></pie-chart>
          <center v-else>No have install agent from clients</center>
          <hr>
          <center>
            <p>Total Client : {{ chart_circle.service_count ? chart_circle.service_count : 0 }} </p>
          </center>
        </b-card>
      </b-col>
      <b-col sm="6" md="3">
        <b-card>
          <pie-chart v-if="chart_circle.price_data && chart_circle.price_data.length" class="animated fadeIn" :donut="true" :data="chart_circle.price_data" :colors="['red', 'orange', 'skyblue']"></pie-chart>
          <center v-else>not yet prepare biling price info</center>
          <hr>
          <center>
            <p>Total Sales : {{ chart_circle.price_count | dollar }} </p>
          </center>
        </b-card>
      </b-col>
      <b-col sm="6" md="3">
        <b-card>
          <center v-if="((dashboard.wmds_count || 0) + (dashboard.wsf_count || 0) + (dashboard.wc_count || 0)) < 1">No have install agent from clients</center>
          <pie-chart label="Value" v-else class="animated fadeIn" :donut="true" :data="[['WMDS',dashboard.wmds_count || 0],['WSFinder',dashboard.wsf_count || 0],['WEBCastle', dashboard.wc_count || 0]]" :colors="['#EB2A03', '#F4F801', '#05E07D']"></pie-chart>
          <hr>
          <center>
            <p>Total Agent Unit  : {{ (dashboard.wmds_count || 0) + (dashboard.wsf_count || 0) + (this.dashboard.wc_count || 0) }} </p>
          </center>
        </b-card>
      </b-col>
    </b-row>
    <vcl-facebook v-if="loading_billing"></vcl-facebook>
    <b-row v-else>
      <b-col sm="12" md="12" id="_share">
        <b-card>
          <b-row>
            <b-col sm="12">
              <h5 style="display:inline-block;">Service usage status by group</h5>
              <b-button variant="link" @click="share()" style="display:inline-block; float:right"> Excel file download </b-button>
              <table class="text-center w-100 font" style="border: black solid 1px;">
                <thead>
                  <tr>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px; background-color:#dcdcdc;" rowspan="2">Group Name</td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px; background-color:#dcdcdc;" colspan="2">Service Type</td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px; background-color:#dcdcdc;" colspan="2">WEBCastle</td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px; background-color:#dcdcdc;" colspan="1">WSFinder</td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px; background-color:#dcdcdc;" colspan="1">WMDS</td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px; background-color:#dcdcdc;" colspan="1">WFDetector</td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px; background-color:#dcdcdc;" rowspan="2">Service Charge <br> (Last month)</td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px; background-color:#dcdcdc;" rowspan="2">Service <br> Charge <br> History</td>
                  </tr>
                  <tr>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px; background-color:#dcdcdc;">Type</td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px; background-color:#dcdcdc;">Use #</td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px; background-color:#dcdcdc;">Installed <br>Agent # </td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px; background-color:#dcdcdc;">Registred <br>Virtual <br>Domains # </td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px; background-color:#dcdcdc;">Installed <br>Agent # </td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px; background-color:#dcdcdc;">Registred <br> Domain # </td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px; background-color:#dcdcdc;">Registred <br> Domain # </td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(group, index) in dashboard.group" v-bind:key="'group_'+index">
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px;">{{group.groupname || 'Error'}}</td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px;">{{group.service_name || '-'}}</td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px;">
                      {{
                        group.wc_usage + group.wsf_usage + group.wmds_usage + group.wf_usage
                      }}
                    </td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px;">{{ group.wc_usage || 0 }} </td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px;">{{ group.wc_usage_domain || 0 }} </td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px;">{{ group.wsf_usage || 0 }} </td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px;">{{ group.wmds_usage || 0 }}</td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px;">{{ group.wf_usage || 0 }}</td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px;">{{ group.last_charge | dollar }}</td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px;">
                      <b-button variant="link" @click="history(group)" style="display:inline-block;"> History </b-button>
                    </td>
                  </tr>
                  <tr v-if="dashboard && dashboard.group && dashboard.group.length">
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px; background-color:#dcdcdc;"> Total </td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px; background-color:#dcdcdc;"></td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px; background-color:#dcdcdc;">
                      {{
                        (dashboard.summary.wc_usage_total + dashboard.summary.wsf_usage_total + dashboard.summary.wmds_usage_total + dashboard.summary.wf_usage_total) || 0
                      }}
                    </td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px; background-color:#dcdcdc;">{{ dashboard.summary.wc_usage_total || 0 }} </td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px; background-color:#dcdcdc;">{{ dashboard.summary.wc_usage_domain_total || 0 }} </td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px; background-color:#dcdcdc;">{{ dashboard.summary.wsf_usage_total || 0 }} </td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px; background-color:#dcdcdc;">{{ dashboard.summary.wmds_usage_total || 0 }} </td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px; background-color:#dcdcdc;">{{ dashboard.summary.wf_usage_total || 0 }} </td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px; background-color:#dcdcdc;">{{ dashboard.summary.last_charge_total | dollar }} </td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px; background-color:#dcdcdc;"></td>
                  </tr>
                  <tr v-else>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px;">N/A</td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px;">N/A </td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px;">N/A </td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px;">N/A </td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px;">N/A </td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px;">N/A </td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px;">N/A </td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px;">N/A </td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px;">N/A </td>
                    <td style="border: black solid 2px; padding: 2px 10px 2px 10px;">-</td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <router-view ></router-view>
  </div>
</template>

<script>
import { Api, auth } from '@/service';
import vSelect from 'vue-select';
import _ from 'lodash'
import htmlToImage from 'html-to-image';
import { saveAs } from 'file-saver';
import { VclFacebook } from 'vue-content-loading';
import moment from 'moment-timezone'
import XLSX from 'xlsx'

export default {
  components : { vSelect, VclFacebook },
  computed: {
  },
  data: () => {
    return {
      auth,
      loading_summary : true,
      loading_chart : true,
      loading_info : true,
      loading_billing : true,
      monthly : [],
      dashboard : {
        group : [],
        summary : { wc_usage_total : 0, wsf_usage_total : 0, wmds_usage_total : 0, wf_usage_total : 0, last_charge_total : 0 }
      },
      chart_circle : {
        service_count : 0,
        service_data : [],
        price_count : 0,
        price_data : [],
      },
    }
  },
  methods: {
    async share() {
      try {
        if(this.exporting) { return; }

        // TODO : 스타일 적용 필요
        var wb = XLSX.utils.book_new();

        // merge
        const merge = [
          { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } },
          { s: { r: 0, c: 1 }, e: { r: 0, c: 2 } },
          { s: { r: 0, c: 3 }, e: { r: 0, c: 4 } },
          { s: { r: 0, c: 8 }, e: { r: 1, c: 8 } },
          { s: { r: 0, c: 9 }, e: { r: 1, c: 9 } },
        ];
        let dataWS = Object.assign({}, { '!ref' : 'A1:I7' })
        let row_index = 1
        dataWS["!merges"] = merge;
        dataWS['A'+row_index] = { s : { fill: { fgColor: { rgb: "#dcdcdc" }, color: { rgb: "#dcdcdc" } } }, v : 'Group Name', t : 's', border: {
      	// underscore
        bottom: {
          style: 'thin',
          color: 'FF000000'
        }
      } }
        dataWS['B'+row_index] = { s : { fill: { fgColor: { argb: "dcdcdc" } } }, v : 'Service Type', t : 's' }
        dataWS['C'+row_index] = { s : { fill: { fgColor: { argb: "dcdcdc" } } }, v : '', t : 's' }
        dataWS['D'+row_index] = { s : { fill: { fgColor: { argb: "dcdcdc" } } }, v : 'WebCastle', t : 's' }
        dataWS['E'+row_index] = { s : { fill: { fgColor: { argb: "dcdcdc" } } }, v : '', t : 's' }
        dataWS['F'+row_index] = { s : { fill: { fgColor: { argb: "dcdcdc" } } }, v : 'WSFinder', t : 's' }
        dataWS['G'+row_index] = { s : { fill: { fgColor: { argb: "dcdcdc" } } }, v : 'WMDS', t : 's' }
        dataWS['H'+row_index] = { s : { fill: { fgColor: { argb: "dcdcdc" } } }, v : 'WFDetector', t : 's' }
        dataWS['I'+row_index] = { s : { fill: { fgColor: { argb: "dcdcdc" } } }, v : 'Service Charge (Last month)', t : 's' }

        // head
        row_index += 1
        dataWS['B'+row_index] = { s : { fill: { fgColor: { argb: "dcdcdc" } } }, v : 'Type', t : 's' }
        dataWS['C'+row_index] = { s : { fill: { fgColor: { argb: "dcdcdc" } } }, v : 'Use', t : 's' }
        dataWS['D'+row_index] = { s : { fill: { fgColor: { argb: "dcdcdc" } } }, v : 'Installed  Agent', t : 's' }
        dataWS['E'+row_index] = { s : { fill: { fgColor: { argb: "dcdcdc" } } }, v : 'Registred Virtual Domains', t : 's' }
        dataWS['F'+row_index] = { s : { fill: { fgColor: { argb: "dcdcdc" } } }, v : 'Installed Agent', t : 's' }
        dataWS['G'+row_index] = { s : { fill: { fgColor: { argb: "dcdcdc" } } }, v : 'Registred Domain', t : 's' }
        dataWS['H'+row_index] = { s : { fill: { fgColor: { argb: "dcdcdc" } } }, v : 'Registred Domain', t : 's' }
        dataWS['I'+row_index] = { s : { fill: { fgColor: { argb: "dcdcdc" } } }, v : 'Service Charge (Last month)', t : 's' }

        // data
        for (let i = 0; i < this.dashboard.group.length; i++) {
          row_index += 1
          console.log('this.dashboard.group[i]', this.dashboard.group[i])
          dataWS['A'+row_index] = { t : 's', v : this.dashboard.group[i].groupname };
          dataWS['B'+row_index] = { t : 's', v : this.dashboard.group[i].service_name };
          dataWS['C'+row_index] = { t : 'n', v : this.dashboard.group[i].wc_usage + this.dashboard.group[i].wf_usage + this.dashboard.group[i].wmds_usage + this.dashboard.group[i].wsf_usage };
          dataWS['D'+row_index] = { t : 'n', v : this.dashboard.group[i].wc_usage };
          dataWS['E'+row_index] = { t : 'n', v : this.dashboard.group[i].wc_usage_domain };
          dataWS['F'+row_index] = { t : 'n', v : this.dashboard.group[i].wsf_usage };
          dataWS['G'+row_index] = { t : 'n', v : this.dashboard.group[i].wmds_usage };
          dataWS['H'+row_index] = { t : 'n', v : this.dashboard.group[i].wf_usage };
          dataWS['I'+row_index] = { t : 'n', v : this.dashboard.group[i].last_charge };
        }


        // TODO :  날짜 넣기 필요
        XLSX.utils.book_append_sheet(wb, dataWS, 'uwss_summary');
        // 엑셀 파일을 내보낸다.
        XLSX.writeFile(wb, 'uwss_summary.xlsx');
        this.exporting = false;
        this.$toastr.s("Shared Image Creation Complete")
      } catch (e) { console.log(e); return this.$toastr.e("export excel failed");  }
    },
    NumberToStr(x) { return `${x}` },
    async load() {
      try {
        let rs = await Api.Billing({target : 'partner', cmd :  'summary'});
        if(rs.is_error) { return this.$toastr.e("load failed") }

        this.dashboard = rs.body;

        this.loading_info = false

        if(this.dashboard && this.dashboard.joined_at) {

          let partnership = new Date().getTime() - new Date(this.dashboard.joined_at).getTime()
          let days = Math.floor(partnership / (1000 * 60 * 60 * 24))
          this.chart_circle = Object.assign({}, this.chart_circle,  { level : Math.floor(days / 365), with_partnership : [["Remaining next Level", 365 - Math.floor(days % 365)], ["Partnership with us", Math.floor(days % 365)]] })
        }

        if(this.dashboard && this.dashboard.service_status) {
          this.chart_circle = Object.assign({}, this.chart_circle,  { service_data : this.dashboard.service_status.map(r => { return [r.service_name, r.count] }) })
          this.chart_circle = Object.assign({}, this.chart_circle,  { service_count : _.sum(_.map(this.chart_circle.service_data, a => a[1])) })
        }

        this.loading_chart = false

        if(this.dashboard && this.dashboard.monthly) {

          let total = { name : 'all', data : {}  }
          this.monthly = _.uniq(_.map(this.dashboard.monthly, r => r.service)).map(r => {
            let rs = { name : r, data : {  } }
            _.map(_.filter(this.dashboard.monthly, x => x.service == r), data => {

              rs.data[moment(data.apply_date,"YYYYMM").format('YYYY-MM-DD')] = data.total
              total.data[moment(data.apply_date,"YYYYMM").format('YYYY-MM-DD')] = ( total.data[moment(data.apply_date,"YYYYMM").format('YYYY-MM-DD')] ? Number(total.data[moment(data.apply_date,"YYYYMM").format('YYYY-MM-DD')]) : 0) + Number(data.total)
            })
            return rs;
          })

          this.chart_circle = Object.assign({}, this.chart_circle,  { price_data : _.map(this.monthly, r => { return [r.name, _.sum(_.map(Object.keys(r.data), k => r.data[k]))] }) })
          this.chart_circle = Object.assign({}, this.chart_circle,  { price_count : _.sum(_.map(this.chart_circle.price_data, a => a[1])) })

          this.monthly.push(total)
        }

        try {
          let rs_qna = await Api.Partner({
            target : 'board.qna',
            cmd : 'list',
            body : { and : [{ name : 'is_answered', value : false, op : "=" }], or : [], sort : [] },
            offset : 0,
            limit : 1
          })
          this.dashboard = Object.assign({}, this.dashboard, { qna : rs_qna.total } )

          this.loading_summary = false
        } catch (e) { console.log(e); this.$toastr.e("load failed") }

        try {
          let rs_notice = await Api.Partner({
            target : 'board.notice',
            cmd : 'list',
            body : { and : [{ name : 'is_del', value : false, op : '=' }], or : [], sort : [] },
            offset : 0,
            limit : 1
          })
          this.dashboard = Object.assign({}, this.dashboard, { notice : rs_notice.total || 0 } )
        } catch (e) { console.log(e); this.$toastr.e("load failed") }

        try {
          let rs_group = await Api.Partner({
            target : 'dashboard',
            cmd : 'summary',
            body : { and : [], or : [], sort : [] },
            offset : 0,
            limit : 1
          })
          if(rs.error) { return new Error(rs.error) }
          this.dashboard = Object.assign({}, this.dashboard, { group : rs_group.body, summary : { wc_usage_total : 0, wsf_usage_total : 0, wmds_usage_total : 0, wf_usage_total : 0, last_charge_total : 0 } } )

          this.loading_billing = false

          for (let i = 0; i < this.dashboard.group.length; i++) {
            let x = this.dashboard.group[i];
            this.dashboard.summary.wc_usage_total += x.wc_usage
            this.dashboard.summary.wsf_usage_total += x.wsf_usage
            this.dashboard.summary.wmds_usage_total += x.wmds_usage
            this.dashboard.summary.wf_usage_total += x.wf_usage
            this.dashboard.summary.last_charge_total += x.last_charge
          }

        } catch (e) { console.log(e); this.$toastr.e("load failed") }

      } catch (e) { console.log(e); this.$toastr.e("Dashboard", 'load failed') }
    },
    history(x) {
      this.$router.push({ name: 'group', params : { id : x.group_id, tab : 5 } })
      this.$toastr.i("Refreshed")
    }
  },
  created () {
    console.log('dashboard.vue created');
  },
  mounted () {
    console.log('dashboard.vue mounted');
    this.load()
  },
  destroyed () {
    console.log('dashboard.vue destroyed');
  },
}
</script>
